import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { useDispatch } from 'react-redux';
import { setHistoricalDsVersionNumber } from 'redux/mode/actions';

const SwitchToLatestAction = () => {
	const dispatch = useDispatch();

	const onClick = () => {
		dispatch(setHistoricalDsVersionNumber(null));
	};

	return <ActionButton icon={IconType.LINE_ARROW_RIGHT} label="Switch to latest" onClick={onClick} />;
};

export default SwitchToLatestAction;
